import { AppProject, DateFormat } from '@common';
import { MPCard, MPTooltip } from '@components';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import CardCover from './CardCover';
import IconSection from './IconSection';
import Styles from './Styles.module.scss';
import useAppCard from './useAppCard';

export default function AppCard({ item }: IProps) {
    const { goToApp } = useAppCard(item);

    return (
        <MPCard
            onClick={goToApp}
            className={Styles.AppCardContainer}
            hoverable
            cover={<CardCover item={item} />}
        >
            <div className={Styles.CardBody}>
                <Typography.Title
                    className={Styles.CardTitle}
                    level={5}
                    ellipsis={true}
                >
                    {item.title}
                    <div className={Styles.CardName}>{item.name}</div>
                </Typography.Title>

                <div className={Styles.DateWrapper}>
                    <div className={Styles.WrapperContainer}>
                        <Typography.Paragraph className={Styles.Date}>
                            {dayjs(item.updatedAt).format(DateFormat.Date)}
                        </Typography.Paragraph>
                        <div className={Styles.GreenDot} />
                        <MPTooltip
                            placement="bottom"
                            title={item.ownerName}
                        >
                            <Typography.Paragraph className={Styles.Owner}>{item.ownerName}</Typography.Paragraph>
                        </MPTooltip>
                    </div>
                </div>
                <IconSection item={item} />
            </div>
        </MPCard>
    );
}

export interface IProps {
    item: AppProject;
    handleModalOpen?: (id: string | null) => void;
}
